import { TenantSettingsPublicIntegrationsSaferpayDto } from './tenant-settings-public-integrations-saferpay.dto';

export class TenantSettingsIntegrationsSaferpayDto extends TenantSettingsPublicIntegrationsSaferpayDto {
  apiUsername?: string | null;
  apiPassword?: string | null;
  customerId?: string | null;
  terminalId?: string | null;
  securePayGateTerminalId?: string | null;
}
